import React, { useState } from "react";
import { Stage, Layer, Rect, Image, Circle, Line, Group } from "react-konva";
import useImage from "use-image";

interface Props {
  src: string;
  width: number;
  height: number;
}

const BackgroundImage: React.FC<React.PropsWithChildren<Props>> = (props) => {
  const [image] = useImage(props.src);
  return <Image image={image} {...props} />;
};

export default BackgroundImage;
